var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStringDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21L17 5.41421L15.7071 6.70711C15.3166 7.09763 14.6834 7.09763 14.2929 6.70711C13.9024 6.31658 13.9024 5.68342 14.2929 5.29289L17.2929 2.29289C17.6834 1.90237 18.3166 1.90237 18.7071 2.29289L21.7071 5.29289C22.0976 5.68342 22.0976 6.31658 21.7071 6.70711C21.3166 7.09763 20.6834 7.09763 20.2929 6.70711L19 5.41421V21Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54102 9.24219H5.45898L4.87305 11H3.00391L6.17969 2.46875H7.80859L11.002 11H9.13281L8.54102 9.24219ZM5.93359 7.81836H8.06641L6.99414 4.625L5.93359 7.81836Z",
    fill: "#B8C6E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98633 20.5879H10.2871V22H3.78906V20.9688L8.00781 14.8926H3.79492V13.4688H10.1934V14.4766L5.98633 20.5879Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStringDesc);
export default __webpack_public_path__ + "static/media/string-desc.7304b00c.svg";
export { ForwardRef as ReactComponent };